import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { AppConfig } from '../../app.config';
import { User} from '../models/user';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Patient } from '../models/patient';
import { PasswordVars, ChangePassword, UserSearchParams } from '../index';
import { BaseService } from './base.service';

@Injectable()
export class UsersService extends BaseService {
    constructor(private http: Http, private config: AppConfig) { super(); }

    getAll(): Observable<User[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/users', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <User[]>response.json();
            }),catchError(this.handleError))
    }



    getAllWithParameters(userSearchParams: UserSearchParams): Observable<User[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users', userSearchParams, { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <User[]>response.json();
            }), catchError(this.handleError))
    }

    
    getUser(id): Observable<User> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/users/'+id, { headers })
            .pipe(map((response: Response) => {
               // console.log(response);
                return <User>response.json();
            }), catchError(this.handleError))
    }

    
    getPatient(patientId): Observable<Patient> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/users/' + patientId+'/patient', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <Patient>response.json();
            }),catchError(this.handleError))
    }

    getPatientImage(patientId): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/users/' + patientId + '/patientimage', { headers })
            .pipe(map((response: Response) => {
                //console.log(response.json());
                var obj = new Patient();
                obj.id = patientId;
                obj.base64Image = response.json();
                return obj;
            }),catchError(this.handleError))
    }

    getPasswordCriteria(userId): Observable<PasswordVars> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/users/' + userId + '/passwordRegx', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <PasswordVars>response.json();
            }),catchError(this.handleError))
    }

    resetPassword(user: User, resetPassword: ChangePassword) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/' + user.id + '/resetpassword', resetPassword, { headers }).pipe(map((response: Response) => {
           // console.log(response);
            return <User>response.json();
        }),catchError(this.handleError))
    }

    toggleEnableUser(user: User) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/' + user.id + '/toggleenableuser',null , { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <User>response.json();
        }),catchError(this.handleError))
    }

    toggleWebAccess(user: User) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/' + user.id + '/togglewebaccess',null,  { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <User>response.json();
        }),catchError(this.handleError))
    }

    toggleUserLock(user: User) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/' + user.id + '/togglelockedout', null, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <User>response.json();
        }),catchError(this.handleError))
    }

    create(user: User) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/createuser', user, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <User>response.json();
        }),catchError(this.handleError))
    }

    update(user: User) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/updateuser', user, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <User[]>response.json();
        }),catchError(this.handleError))
    }

    updatePatient(user: Patient) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/users/updatepatient', user, { headers })
            .pipe(map((response: Response) => {
               // console.log(response);
                return <Patient>response.json();
            }),catchError(this.handleError))
    }


    delete(id: number) {
        return this.http.delete(this.config.apiUrl + '/users/' + id, this.jwt());
    }

    
}



// WEBPACK FOOTER //
// ./src/app/shared/services/users.service.ts